import { EMPTY_OBJECT } from 'uf/base';
import { UFState } from 'uf/state';
import { UserState } from 'uf/user/state';

export function getUserState(state: UFState): UserState {
  return state.user || (EMPTY_OBJECT as UserState);
}
